import Typography from '@material-ui/core/Typography';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';

const AppDropdownButton = ({
  title,
  options,
  loading,
  value,
  disabled,
  onChange,
  required = false,
  color = undefined,
}) => {
  const [ open, setOpen ] = useState(false);

  return (
    <Grid container>
      <Grid item xs={ 12 }>
        <Typography variant='subtitle'>
          {title}
        </Typography>
      </Grid>
      <Grid item xs={ 12 }>
        <Autocomplete
          open={ open }
          onOpen={ () => {
            setOpen(true);
          } }
          onClose={ () => {
            setOpen(false);
          } }
          getOptionSelected={ (option, v) => {
            return option.id === v.id;
          } }
          getOptionLabel={ (option) => { return option.name || ''; } }
          options={ options || [] }
          loading={ loading }
          color={ color }
          value={ value }
          disabled={ !!disabled }
          onChange={ (event, newValue) => {
            onChange(newValue);
          } }
          renderInput={ (params) => {
            return (
              <TextField
                { ...params }
                placeholder='Add an item...'
                variant='outlined'
                size='small'
                color={ color }
                required={ required }
                style={ { marginBottom: '8px' } }
                InputProps={ {
                  ...params.InputProps,
                  endAdornment: (
                    <>
                      {loading ? <CircularProgress color='inherit' size={ 20 } /> : null}
                      {params.InputProps.endAdornment}
                    </>
                  ),
                } }
              />
            );
          } }
        />
      </Grid>
    </Grid>
  );
};

export default AppDropdownButton;
